/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

import type { MarketingProvidersResponse } from ".././types/marketing"

export const getGetMarketingProvidersResponseMock = (
	overrideResponse: Partial<Extract<MarketingProvidersResponse, object>> = {},
): MarketingProvidersResponse => ({
	providers: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		channels: ["sms", "whatsapp", "telegram"],
	})),
	...overrideResponse,
})

export const getGetMarketingProvidersMockHandler = (
	overrideResponse?:
		| MarketingProvidersResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MarketingProvidersResponse> | MarketingProvidersResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/providers/:businessId",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingProvidersResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}
export const getMarketingProvidersMock = () => [
	getGetMarketingProvidersMockHandler(),
]
